
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerBudgetProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerBudgetProfile"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period5"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period6"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period7"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period8"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period9"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period10"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period11"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period12"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":238}};
    doc.loc.source = {"body":"fragment CustomerBudgetProfileFragment on CustomerBudgetProfile {\n  id\n  concurrencyVersion\n  uuid\n  description\n  period1\n  period2\n  period3\n  period4\n  period5\n  period6\n  period7\n  period8\n  period9\n  period10\n  period11\n  period12\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CustomerBudgetProfileFragment"] = oneQuery(doc, "CustomerBudgetProfileFragment");
        
